// @flow

import { createAction, handleActions } from 'redux-actions'

const BASE_ACTION = '@@network'

export const actions = {
  setRedirectUrl: createAction(`${BASE_ACTION}/SET_REDIRECT_URL`),
  setLoading: createAction(`${BASE_ACTION}/SET_LOADING`),
}

/**
 * Reducer section
 */
const initialState = {
  redirectUrl: '',
  isLoading: false,
}

// FlowType
type Action = {
  type: string,
  payload: any,
}

export const reducer = handleActions(
  {
    [actions.setRedirectUrl().type]: (state, action) =>
      Object.assign({}, state, { redirectUrl: action.payload }),
    [actions.setLoading().type]: (state, action) =>
      Object.assign({}, state, { isLoading: action.payload }),
  },
  initialState,
)
